/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".message-container[_ngcontent-%COMP%]{background-color:#3e4148;text-align:center;color:#fff;font-size:1rem;padding:10px 18px}.count-down[_ngcontent-%COMP%]{color:#62c2de;font-weight:700;margin-left:15px}.resend-btn[_ngcontent-%COMP%]{color:#62c2de;text-decoration:underline;font-weight:700;margin-left:15px;cursor:pointer}"];
export { styles as styles };
